<script>

    import { QuotationStore } from '../stores'

    import MenuMain from '../$layouts/menu.main.svelte'

    import Main from '../requests/main.svelte'
    import Prices from '../requests/prices.svelte'
    import Shipment from '../requests/shipment.svelte'
    import LocationSelect from '../locations/location.select.svelte'

    let step = 'main'
    let mainData = {}
    let pickup = {}
    let delivery = {}
    let pricing = {}

    function quotationSuccess() {
        step = 'prices'
    }

    function quotationSelected(event) {
        step = 'pickup'
        pickup = $QuotationStore.pickup
        delivery = $QuotationStore.delivery
        pricing = event.detail
    }

    function pickupSelected() {
        step = 'delivery'
    }

    function deliverySelected() {
        step = 'details'
    }

	function onReset() {
		QuotationStore.set(null)
		step = 'main'
        mainData = {}
		pickup = {}
		delivery = {}
		pricing = {}
	}

    function onStep(event) {
        step = event.detail
    }

</script>

<MenuMain />

<div class="container">
    <div class="columns">
        {#if step === 'main'}
            <div class="column">
                <Main on:success={ quotationSuccess } on:step={onStep} bind:data={mainData} />
            </div>
        {:else if step === 'prices'}
            <div class="column is-6 is-offset-3">
                <Prices on:selected={ quotationSelected } on:step={onStep} />
            </div>
        {:else if step === 'pickup'}
            <div class="column is-6 is-offset-3">
                <LocationSelect label="Origen" bind:location={ pickup } on:selected={ pickupSelected } on:canceled={() => onStep({detail: 'prices'})} />
            </div>
        {:else if step === 'delivery'}
            <div class="column is-6 is-offset-3">
                <LocationSelect label="Destino" bind:location={ delivery } on:selected={ deliverySelected } on:canceled={() => onStep({detail: 'pickup'})} />
            </div>
        {:else if step === 'details'}
            <div class="column is-6 is-offset-3">
                <Shipment on:reset={onReset} on:step={onStep} bind:pickup={ pickup } bind:delivery={ delivery } bind:pricing={ pricing } />
            </div>
        {/if}
    </div>
    <br>
    <br>
</div>